<template>
  <div id="app">
    <transition :name="viewAnimate">
      <keep-alive>
        <navigation>
          <router-view
            class="router_Page"
            v-wechat-title="$route.meta.title"
            v-if="flag"
          />
        </navigation>
      </keep-alive>
    </transition>
    <div id="toast" v-show="toast.show">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i
          v-show="toast.icon == 'success'"
          class="weui-icon_toast weui-icon-success-no-circle"
        ></i>
        <p class="weui-toast__content">{{ toast.title }}</p>
      </div>
    </div>
    <div id="loadingToast" v-show="loadingToast.show">
      <div class="weui-mask_transparent"></div>
      <div class="weui-toast">
        <i class="weui-loading weui-icon_toast"></i>
        <p class="weui-toast__content">{{ loadingToast.title }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { qyWechatlogin, initDictWhenLogin, fetchUserInfo } from './utils/api'
import storage from './utils/storage'
import { mapActions, mapGetters } from 'vuex'
import wx from 'weixin-js-sdk'

export default {
  name: 'App',
  components: {},
  data() {
    return {
      flag: false,
      viewAnimate: ''
    }
  },
  created() {
    let self = this

    this.$navigation.on('forward', () => {
      this.viewAnimate = 'slide-left'
    })
    this.$navigation.on('back', () => {
      this.viewAnimate = 'slide-right'
    })
    this.$navigation.on('replace', () => {
      this.viewAnimate = 'slide-left'
    })
    /**
     * 判断是否在微信体系
     */
    let ua = window.navigator.userAgent.toLowerCase()
    if (ua.indexOf('micromessenger') > -1) {
      // 微信环境
      /**
       * 判断页面是否在小程序中打开
       */
      wx.miniProgram.getEnv(res => {
        //在小程序里
        if (res.miniprogram) {
          window.history.pushState('forward', null, '#')
          window.history.forward(1)
          window.addEventListener(
            'popstate',
            () => {
              // 跳转到上一个小程序页面
              wx.miniProgram.postMessage({
                data: {
                  data: 'back'
                }
              })
              wx.miniProgram.navigateBack({
                delta: 1
              })
            },
            false
          )

          /**
           * 在小程序中打开时  不走微信获取code无感登录  直接从小程序传入 access_token和companyId、以及userId
           */
          self.actionSence(1)
          let access_token_miniProgram = decodeURI(
            self.$route.query.access_token
          )
          let companyId_miniProgram = decodeURI(self.$route.query.companyId)
          storage.set('access_token', access_token_miniProgram)
          storage.set('companyId', companyId_miniProgram)
          self.getUserSpaceUpInfo()
        } else {
          console.log('在微信体系，但不在小程序里')
          //不在小程序里
          self.qyWxLogin()
          self.actionSence(0)
        }
      })
    } else {
      /**
       * 判断是否在微信体系
       */
      console.log('不在微信体系=====模拟数据')
      let companyId = 2 //公司id
      storage.set(
        'access_token',
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb21wYW55SWQiOjIsInVzZXJfbmFtZSI6IjE4NTExOTA0NjUxIiwic2NvcGUiOlsic2VydmVyIl0sImV4cCI6MTY0MjgxODk1MywidXNlcklkIjo0NDksImp0aSI6IjkxNDc1Y2U3LTg4MGItNDE5YS1hZDFkLWYyYjhhMjg4OGUzYyIsImNsaWVudF9pZCI6InNhYXMifQ.eaZ9kPmcJY-d4Xo4Yffs5BMkuUCs2iFUtfORaQZFCBI'
      )
      storage.set('companyId', companyId)
      this.getUserSpaceUpInfo()
      this.actionSence(2)
    }
  },
  methods: {
    ...mapActions(['actionUserInfo', 'actionAllSelect', 'actionSence']),
    /**
     * 企业微信 鉴权登录
     */
    qyWxLogin() {
      let self = this
      let companyId = ''

      if (process.env.VUE_APP_APP_HOST) {
        companyId = 5 //同创
      } else {
        companyId = 128 //万翼
      }

      /**
       * 不是微信环境  模拟登录数据
       */
      storage.set('code', this.$route.query.code)
      storage.set('companyId', companyId)
      console.log('企业微信登录parmes')
      console.log(this.$route.query.code)
      qyWechatlogin(
        {
          companyId: companyId,
          code: this.$route.query.code, //'YKd4QSlXzQb0ZPnNxATGtQ==',//this.$route.query.code
          channel: 'Nude'
        },
        {}
      ).then(
        res => {
          if (res.access_token) {
            storage.set('access_token', res.access_token)
            storage.set('companyId', res.companyId)
            self.getUserSpaceUpInfo()
          }
        },
        err => {
          console.log('获取用户数据失败')
          this.flag = true
        }
      )
    },
    getUserSpaceUpInfo() {
      fetchUserInfo({
        companyId: storage.get('companyId')
      }).then(
        res => {
          this.actionUserInfo(res.data)
          this.initDictWhenLogin()
          this.flag = true
        },
        err => {
          console.log('获取用户数据失败')
          this.flag = true
        }
      )
    },
    initDictWhenLogin() {
      initDictWhenLogin().then(res => {
        this.actionAllSelect(res.data)
      })
    }
  },
  computed: {
    ...mapGetters([
      // 从store上绑定的getters中载入需要的到此组件中
      'toast',
      'loadingToast'
    ])
  }
}
</script>

<style lang="less">
@import './assets/css/common.less';

html {
  background: @colore !important;
}

#app {
  margin: 0 auto;
  position: relative;
}

.router_Page {
  min-height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: #fff;
}

//转场动画
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  // -webkit-transform-style: preserve-3d;
  // -webkit-backface-visibility: hidden;
  // -webkit-perspective: 1000;
  // 启用硬件加速
  will-change: transform;
  transition: all 300ms ease-in-out;
}

.slide-right-enter {
  opacity: 0;
  transform: translate(-100%, 0);
  transition-timing-function: ease-in-out;
}

.slide-right-leave-active {
  opacity: 0;
  // 安卓手机上同时进行离开和进入会出现闪白现象，暂时不启用离开动画
  transform: translate(100%, 0);
  transition-timing-function: cubic-bezier(0.5, 0, 1, 1);
}

.slide-left-enter {
  opacity: 0;
  transform: translate(100%, 0);
  transition-timing-function: ease-in-out;
}

.slide-left-leave-active {
  opacity: 0;
  // 安卓手机上同时进行离开和进入会出现闪白现象，暂时不启用离开动画
  transition-timing-function: cubic-bezier(0.5, 0, 1, 1);
  transform: translate(-100%, 0);
}
</style>
